import { toast } from "react-toastify";
import { Post } from "../../AxiosCRUDFunctions";
import { apiHeader, BaseURL } from "../../config";
import { getToken } from "../../helpers/tokenStorage";

export const getTopDoctorsByMedicineIdApi = async (data) => {
  const response = await Post(
    BaseURL("doctor/get-top-doctor-By-medicineId"),
    data,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};

export const getTopDoctorsByLocationIdApi = async (data) => {
  const response = await Post(
    BaseURL("doctor/get-top-doctor-By-locationId"),
    data,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};


export const getTopMedicinesByLocationIdApi = async (data) => {
  const response = await Post(
    BaseURL("medicine/get-top-medicine-By-locationId"),
    data,
    apiHeader(getToken())
  );
  if (response?.data?.headers?.error === 200) return response?.data?.body;
  toast.error(response?.data?.headers?.message);
  return null;
};
